var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49609 8.77018C8.68019 8.77018 8.82943 8.91942 8.82943 9.10352V10.9258C8.82934 11.1098 8.68014 11.2591 8.49609 11.2591H7.50391C7.31986 11.2591 7.17066 11.1098 7.17057 10.9258V9.10352C7.17057 8.91942 7.31981 8.77018 7.50391 8.77018H8.49609Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C11.8667 1 15 4.13333 15 8C15 11.8667 11.8667 15 8 15C4.13333 15 1 11.86 1 8C1 4.14 4.13333 1 8 1ZM7.9974 4C7.92742 4 7.85923 4.0234 7.80404 4.06641L3.33333 7.55273L3.72005 8.04167L4.26693 7.61523V11.4661C4.26726 11.6311 4.3326 11.7896 4.44922 11.9062C4.56578 12.0228 4.72387 12.0881 4.88867 12.0885H11.1113C11.2761 12.0882 11.4342 12.0228 11.5508 11.9062C11.6674 11.7896 11.7328 11.6311 11.7331 11.4661V7.61784L12.2799 8.04427L12.6667 7.55534L8.19076 4.06641C8.13559 4.02336 8.06737 4.00005 7.9974 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHouse);
export default __webpack_public_path__ + "static/media/ic-house.d8c8addc0b43cbf18554323f9e323320.svg";
export { ForwardRef as ReactComponent };